import script from "./Ad2Molecule.vue?vue&type=script&setup=true&lang=js"
export * from "./Ad2Molecule.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__